import Vue from 'vue'
import Vuex from 'vuex'
import API from './api'

Vue.use(Vuex)

let api = new API()

const actions = {
  fetchInitialData: (state) => {
    api.getCore(function (response) {
      state.commit('setInitialData', response.data)
    })
  },

  fetchTermsData: (state) => {
    api.getTerms(function (response) {
      state.commit('setTermsData', response.data)
    })
  },

  fetchTilesData: (state) => {
    api.getTiles(function (response) {
      state.commit('setTilesData', response.data.data)
    })
  },

  fetchGameData: (state, gameId) => {
    var force = 0
    if (typeof gameId === 'object') {
      force = gameId.force
      gameId = gameId.id
    }
    var gameIndex = state.state.gameData.findIndex(function (obj) {
      return obj.id === parseInt(gameId)
    })

    if (gameIndex !== -1 && force === 0) {
      // no AJAX needed
      Vue.set(state.state.gameData, gameIndex, state.state.gameData[gameIndex])
    } else {
      // make API call
      if (gameIndex !== -1) {
        Vue.delete(state.state.gameData, gameIndex)
      }
      api.getGame(gameId, function (response) {
        state.commit('setGameData', {
          'gameId': gameId,
          'data': response.data
        })
      })
    }
  },

  fetchLessonData: async (state, lessonId) => {
    await api.getLesson(lessonId, function (response) {
      response.data.clone = true;
      state.commit('setLessonData', {
        'lessonId': lessonId,
        'data': response.data
      })
    })
  },

  fetchJourneyData: async (state, journeyId) => {
    await api.getJourney(journeyId, function (response) {
      state.commit('setJourneyData', {
        'journeyId': journeyId,
        'data': response.data
      })
    })
  },

  fetchHelpData: (state, routeName) => {
    api.getHelp(routeName, function (response) {
      state.commit('setHelpData', {
        'routeName': routeName,
        'data': response.data
      })
    })
  },

  clearLessonForm () {
    state.selectedTiles = [];
    state.lessonForm.name = '';
    state.lessonForm.description = '';
    state.lessonForm.notes = '';
    state.lessonForm.group = {};
    state.lessonForm.topic = {};
    state.lessonForm.subtopic = {};
  }

}

const mutations = {
  setWindowTitle (state, title) {
    state.windowTitle = title
  },
  setLessonUserId (state, userId) {
    state.lessonUserId = userId
  },
  setInitialData (state, data) {
    state.concepts = data.concepts
    state.foundations = data.foundations
    state.lessons = data.lessons
    state.basicTiles = data.basicTiles
    state.versions = data.versions
    state.versionId = data.versionId
    state.journeys = data.journeys
  },
  setVersionId (state, data) {
    state.versionId = data;
  },
  setTermsData (state, data) {
    state.terms = data.text
  },
  setTilesData (state, data) {
    state.tiles = data
  },
  setTilesSearchData (state, data) {
    state.searchTiles = data
  },
  setGameData (state, payload) {
    state.gameData.push(payload.data)
  },

  setLessonData (state, payload) {
    state.lessonData = payload.data
  },

  setJourneyData (state, payload) {
    state.journeyData = payload.data.journey;
    state.journeyData.lessons = payload.data.lessons;
  },

  setLessonForm (state, payload) {
    state.lessonForm = payload
  },
  setHelpData (state, payload) {
    state.helpData.push(payload.data)
  },
  setSelectedTiles (state, tiles) {
    tiles.forEach(function (tile, key) {
      if (tile.id !== undefined && state.selectedTiles) {
        var index = state.selectedTiles.findIndex(function (obj) {
          if (obj !== undefined) {
            return obj.id === tile.id
          }
        })

        // console.log("index " +index + " in set selected tiles " + tile.id)

        if (index === -1) {
          // console.log('not found ' + tile.id)
          tile.selected = true
          state.selectedTiles.push(tile)
        } else {
          // console.log('Found ' + tile.id)

        }
      }
    })
  },
  setLessonFormConcept (state, concept) {
    state.lessonForm.concept_id = concept
  },
  setLessonFormName (state, name) {
    state.lessonForm.name = name
  },
  setLessonFormDescription (state, description) {
    state.lessonForm.description = description
  },

  setLibraryPage (state, page) {
    state.pagination.library = page;
  }
}

const state = {
  email: null,
  token: null,
  windowTitle: null,
  lessonUserId: null,
  concepts: [],
  journeys: [],
  foundations: [],
  lessons: [],
  versions: [],
  versionId: null,
  terms: 'T & C',
  tiles: [],
  searchTiles: [],

  // Use on lesson new default values
  basicTiles: [],

  // Use the tiles selected on library/index
  selectedTiles: [],

  lessonForm: {},

  gameData: [],
  lessonData: {},
  journeyData: {},
  helpData: [],
  pagination: {
    library: 1
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
